import React, { useState } from 'react';

const TheatreCard = ({ theatre, onSelectTimeSlot, showPrice, priceOverride }) => {
  const images = theatre.imagePaths?.length
    ? theatre.imagePaths
    : theatre.image
    ? [theatre.image]
    : [];
  const [selectedSlot, setSelectedSlot] = useState(
    theatre.timeSlots?.find((slot) => slot.selected)?.label || ''
  );
  const [activeImage, setActiveImage] = useState(0);

  const handleSlotClick = (slot) => {
    if (slot.disabled) return;
    setSelectedSlot(slot.label);
    if (onSelectTimeSlot) {
      onSelectTimeSlot(slot);
    }
  };

  const showPrev = () => {
    setActiveImage((idx) => (idx === 0 ? images.length - 1 : idx - 1));
  };

  const showNext = () => {
    setActiveImage((idx) => (idx === images.length - 1 ? 0 : idx + 1));
  };

  return (
    <div className="theatre-card">
      <div className="theatre-image-container">
        {images.length > 0 && (
          <img src={images[activeImage]} alt={theatre.name} className="theatre-image" />
        )}
        <div className="theatre-hero-copy">
          <span>Private theatre</span>
          <h4>{theatre.name}</h4>
        </div>
        {theatre.slotsAvailableText && (
          <span className={`slot-count slot-count-${theatre.slotsStatus}`}>
            {theatre.slotsAvailableText}
          </span>
        )}
        {images.length > 1 && (
          <>
            <button type="button" className="carousel-nav prev" onClick={showPrev} aria-label="Previous image">
              &lsaquo;
            </button>
            <button type="button" className="carousel-nav next" onClick={showNext} aria-label="Next image">
              &rsaquo;
            </button>
            <div className="carousel-dots">
              {images.map((_, i) => (
                <button
                  key={i}
                  type="button"
                  className={`dot${i === activeImage ? ' active' : ''}`}
                  onClick={() => setActiveImage(i)}
                  aria-label={`Show image ${i + 1}`}
                />
              ))}
            </div>
          </>
        )}
        {false && (
          <div className="rating-badge">
            <i className="bi bi-star-fill" />
            {theatre.rating}
          </div>
        )}
        {theatre.videoLinks?.length > 0 && (
          <div className="video-links">
            {theatre.videoLinks.map((video) => (
              <a
                key={video.url}
                href={video.url}
                className="video-link"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-play-fill" /> {video.label}
              </a>
            ))}
          </div>
        )}
      </div>

      <div className="theatre-content">
        <div className="theatre-header">
          <span className="location-chip">
            <i className="bi bi-geo-alt" />
            {theatre.location}
          </span>
          <div className="action-buttons">
            {theatre.mapsUrl && (
              <a className="action-btn maps-btn" href={theatre.mapsUrl} target="_blank" rel="noreferrer">
                <i className="bi bi-geo-alt-fill" aria-hidden="true" />
                MAPS
              </a>
            )}
            {theatre.foodUrl && (
              <a className="action-btn food-btn" href={theatre.foodUrl} target="_blank" rel="noreferrer">
                <i className="bi bi-cup-straw" aria-hidden="true" />
                FOOD
              </a>
            )}
          </div>
        </div>

        {theatre.features?.length > 0 && (
          <div className="features-row">
            {theatre.features.map((feature) => (
              <span key={feature} className="feature-item">
                <i className="bi bi-check-circle" />
                {feature}
              </span>
            ))}
          </div>
        )}

        {theatre.timeSlots?.length > 0 && (
          <>
            <h5 className="time-slots-title">Select Time Slot</h5>
            <div className="time-slots-grid">
              {theatre.timeSlots.map((slot) => {
                const isSelected = slot.selected || selectedSlot === slot.label;
                return (
                  <div
                    key={slot.label}
                    className={`time-slot${slot.disabled ? ' disabled' : ''}${
                      isSelected ? ' selected' : ''
                    }`}
                    role="button"
                    tabIndex={0}
                    onClick={() => handleSlotClick(slot)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleSlotClick(slot);
                      }
                    }}
                  >
                    {slot.label}
                    {slot.discount && (
                      <span className="time-slot-discount">{slot.discount}</span>
                    )}
                  </div>
                );
              })}
            </div>
          </>
        )}

        {showPrice && (priceOverride || theatre.priceMain) && (
          <div className="pricing-section">
            <div className="price-main">
              {priceOverride || theatre.priceMain}{' '}
              {priceOverride
                ? null
                : theatre.priceSuffix && <span className="price-suffix">{theatre.priceSuffix}</span>}
            </div>
            {!priceOverride && theatre.priceExtra && (
              <div className="price-extra">{theatre.priceExtra}</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TheatreCard;
